export const UPDATEDATA = "UPDATEDATA";
export const INITIALDATA = "INITIALDATA";
export const FILTERDATA = "FILTERDATA";
export const EXPAND = "EXPAND";
export const SORT = "SORT";
export const EXPERIMENT = "EXPERIMENT";
export const NOSSR = "NOSSR";
export const NEWSHOE = "NEWSHOE";
export const ADDFAV = "ADDFAV";
export const REMOVEFAV = "REMOVEFAV";
export const SETFILTERS = "SETFILTERS";
export const APPLYFILTER = "APPLYFILTER";
export const PAGINATION = "PAGINATION";
export const SEARCHTEXT = "SEARCHTEXT";
export const EDITING = "EDITING";
export const SWITCH = "SWITCH";
export const NOTIFICATIONS = "NOTIFICATIONS";
export const LASTVISIT = "LASTVISIT";
export const COLLAPSFILTER = "COLLAPSFILTER";
export const SETFILTERSTYLE = "SETFILTERSTYLE";
export const FETCHEDADDITIONALDATA = "FETCHEDADDITIONALDATA";
export const ADD_LIKE = "ADD_LIKE";
export const DELETE_LIKE = "DELETE_LIKE";
export const UPDATELIKECOUNTER = "UPDATELIKECOUNTER";
export const SETSORTESTYLESBY = "SETSORTESTYLESBY";
export const INITIATE_QUESTIONS = "INITIATE_QUESTIONS";
export const CHANGE_QUESTION = "CHANGE_QUESTION";
export const CHANGE_ANSWER = "CHANGE_ANSWER";
export const QUIZ_FILTER = "QUIZ_FILTER";
export const GETDATAV2 = "GETDATAV2";
export const FILTERING = "FILTERING";
export const SHOEDATA = "SHOEDATA";
export const ABORTFUNCTION = "ABORTFUNCTION";
export const FILTEROBJECT = "FILTEROBJECT";
export const URLMAPPING = "URLMAPPING";
export const COLLAPSALLFILTER = "COLLAPSALLFILTER";
export const NEW_COUNT = "NEW_COUNT";
export const QUIZ_OUTPUTDATA = "QUIZ_OUTPUTDATA";
export const MENU = "MENU";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const REHYDRATION_FINISHED = "REHYDRATION_FINISHED";
export const VISITEDQUIZ = "VISITEDQUIZ";
export const OVERVIEW = "OVERVIEW";
